var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Alert, Badge, Button, Image, Input, Modal, Tabs, Tag, message, } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, ClockCircleOutlined, } from '@ant-design/icons';
import './ProfileModerationPage.scss';
import { isProfileModerationEnabled } from '@/config/featureFlags';
import { useApproveProfileModerationMutation, useDeleteProfileModerationMutation, useGetProfileModerationEnabledQuery, useGetProfileModerationPendingCountQuery, useGetProfileModerationRequestsQuery, useRejectProfileModerationMutation, } from '@/services/profileModerationApi';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '@/hooks/redux';
import { ADMIN_PATHS } from '@/routes/paths/adminPaths';
var statusLabels = {
    pending: 'В ожидании',
    approved: 'Одобрено',
    rejected: 'Отклонено',
};
var ProfileModerationPage = function () {
    var user = useAppSelector(function (state) { return state.authStich.currentUser; });
    var isSystemAdmin = (user === null || user === void 0 ? void 0 : user.role) === 'системный администратор';
    var uiEnabled = isProfileModerationEnabled;
    var serverFlag = useGetProfileModerationEnabledQuery(undefined, {
        skip: !isSystemAdmin,
    }).data;
    var actionsEnabled = uiEnabled && (serverFlag === null || serverFlag === void 0 ? void 0 : serverFlag.enabled) === true;
    var _a = useState('all'), filterType = _a[0], setFilterType = _a[1];
    var _b = useState({
        id: 0,
        open: false,
    }), rejectModal = _b[0], setRejectModal = _b[1];
    var _c = useState(''), rejectReason = _c[0], setRejectReason = _c[1];
    var _d = useGetProfileModerationRequestsQuery(undefined, { skip: !isSystemAdmin }), _e = _d.data, allRequests = _e === void 0 ? [] : _e, isLoading = _d.isLoading, isError = _d.isError;
    var requests = filterType === 'all'
        ? allRequests
        : allRequests.filter(function (r) { return r.status === filterType; });
    var _f = useGetProfileModerationPendingCountQuery(undefined, {
        skip: !uiEnabled || !isSystemAdmin,
    }).data, pendingCount = _f === void 0 ? 0 : _f;
    var approve = useApproveProfileModerationMutation()[0];
    var reject = useRejectProfileModerationMutation()[0];
    var remove = useDeleteProfileModerationMutation()[0];
    var counts = {
        all: allRequests.length,
        pending: allRequests.filter(function (r) { return r.status === 'pending'; }).length,
        approved: allRequests.filter(function (r) { return r.status === 'approved'; }).length,
        rejected: allRequests.filter(function (r) { return r.status === 'rejected'; }).length,
    };
    var handleApprove = function (id) {
        if (!actionsEnabled) {
            message.warning('Модерация профилей пока отключена');
            return;
        }
        Modal.confirm({
            title: 'Одобрить заявку?',
            content: 'Фото будет опубликовано в профиле пользователя. Push-уведомление будет отправлено.',
            okText: 'Одобрить',
            cancelText: 'Отмена',
            onOk: function () {
                return __awaiter(void 0, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                _b.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, approve(id).unwrap()];
                            case 1:
                                _b.sent();
                                message.success('Заявка одобрена');
                                return [3 /*break*/, 3];
                            case 2:
                                _a = _b.sent();
                                message.error('Ошибка при одобрении');
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            },
        });
    };
    var openReject = function (id) {
        if (!actionsEnabled) {
            message.warning('Модерация профилей пока отключена');
            return;
        }
        setRejectReason('');
        setRejectModal({ id: id, open: true });
    };
    var handleRejectSubmit = function () {
        return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, reject({ id: rejectModal.id, reason: rejectReason.trim() || undefined }).unwrap()];
                    case 1:
                        _b.sent();
                        message.success('Заявка отклонена');
                        setRejectModal({ id: 0, open: false });
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        message.error('Ошибка при отклонении');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    var handleDelete = function (id) {
        if (!actionsEnabled) {
            message.warning('Модерация профилей пока отключена');
            return;
        }
        Modal.confirm({
            title: 'Удалить заявку?',
            okText: 'Удалить',
            okType: 'danger',
            cancelText: 'Отмена',
            onOk: function () {
                return __awaiter(void 0, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                _b.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, remove(id).unwrap()];
                            case 1:
                                _b.sent();
                                message.success('Заявка удалена');
                                return [3 /*break*/, 3];
                            case 2:
                                _a = _b.sent();
                                message.error('Ошибка при удалении');
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            },
        });
    };
    var tabItems = [
        { key: 'all', label: "\u0412\u0441\u0435 (".concat(counts.all, ")") },
        { key: 'pending', label: "\u0412 \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u0438 (".concat(counts.pending, ")") },
        { key: 'approved', label: "\u041E\u0434\u043E\u0431\u0440\u0435\u043D\u043E (".concat(counts.approved, ")") },
        { key: 'rejected', label: "\u041E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u043E (".concat(counts.rejected, ")") },
    ];
    if (!isSystemAdmin) {
        return _jsx(Navigate, { to: ADMIN_PATHS.ESTABLISHMENTS, replace: true });
    }
    if (isLoading)
        return _jsx("p", __assign({ className: "ProfileModerationPage" }, { children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..." }));
    if (isError)
        return _jsx("p", __assign({ className: "ProfileModerationPage" }, { children: "\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u0437\u0430\u044F\u0432\u043E\u043A" }));
    return (_jsxs("div", __assign({ className: "ProfileModerationPage" }, { children: [_jsxs("div", __assign({ className: "titleBlock" }, { children: [_jsx("span", { children: "\u041C\u043E\u0434\u0435\u0440\u0430\u0446\u0438\u044F \u043F\u0440\u043E\u0444\u0438\u043B\u0435\u0439" }), uiEnabled && pendingCount > 0 && (_jsx(Badge, { count: pendingCount, style: { marginLeft: 12 } }))] })), _jsxs("div", __assign({ className: "content" }, { children: [!uiEnabled && (_jsx(Alert, { type: "info", showIcon: true, style: { marginTop: 16 }, message: "\u0420\u0430\u0437\u0434\u0435\u043B \u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043B\u0435\u043D, \u043D\u043E \u043F\u043E\u043A\u0430 \u043D\u0435 \u0430\u043A\u0442\u0438\u0432\u0435\u043D", description: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 REACT_APP_PROFILE_MODERATION_ENABLED=true \u0432 \u0430\u0434\u043C\u0438\u043D\u043A\u0435 \u0438 PROFILE_MODERATION_ENABLED=true \u043D\u0430 \u0431\u044D\u043A\u0435\u043D\u0434\u0435, \u0447\u0442\u043E\u0431\u044B \u0432\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043C\u043E\u0434\u0435\u0440\u0430\u0446\u0438\u044E. \u0422\u0435\u043A\u0443\u0449\u0430\u044F \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0444\u043E\u0442\u043E \u0432 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438 \u043D\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0430." })), uiEnabled && !(serverFlag === null || serverFlag === void 0 ? void 0 : serverFlag.enabled) && (_jsx(Alert, { type: "warning", showIcon: true, style: { marginTop: 16 }, message: "\u0411\u044D\u043A\u0435\u043D\u0434: \u043C\u043E\u0434\u0435\u0440\u0430\u0446\u0438\u044F \u0432\u044B\u043A\u043B\u044E\u0447\u0435\u043D\u0430", description: "PROFILE_MODERATION_ENABLED=false \u2014 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0430 \u0441 \u043C\u043E\u0431\u0430\u0439\u043B\u0430 \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u0430. \u041E\u0434\u043E\u0431\u0440\u0435\u043D\u0438\u0435/\u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u0438\u0435 \u0432 \u0430\u0434\u043C\u0438\u043D\u043A\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u0434\u043B\u044F \u0442\u0435\u0441\u0442\u043E\u0432\u044B\u0445 \u0437\u0430\u044F\u0432\u043E\u043A." })), _jsx(Tabs, { activeKey: filterType, onChange: function (key) { return setFilterType(key); }, items: tabItems, style: { marginTop: 16 } }), _jsx("div", __assign({ className: "requestsGrid" }, { children: requests.map(function (req) {
                            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                            var snap = req.profileSnapshot;
                            var oldPhoto = (_a = snap === null || snap === void 0 ? void 0 : snap.previousPhotoURL) !== null && _a !== void 0 ? _a : (_b = req.user) === null || _b === void 0 ? void 0 : _b.photoURL;
                            var profileName = (_f = (_c = snap === null || snap === void 0 ? void 0 : snap.name) !== null && _c !== void 0 ? _c : (_e = (_d = req.user) === null || _d === void 0 ? void 0 : _d.profile) === null || _e === void 0 ? void 0 : _e.name) !== null && _f !== void 0 ? _f : (_g = req.user) === null || _g === void 0 ? void 0 : _g.fullName;
                            return (_jsxs("div", __assign({ className: "requestCard" }, { children: [_jsxs("div", __assign({ className: "photoCompare" }, { children: [_jsxs("div", __assign({ className: "photoBlock" }, { children: [_jsx(Image, { src: oldPhoto || undefined, alt: "\u0411\u044B\u043B\u043E", fallback: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Crect fill='%23eee' width='100' height='100'/%3E%3C/svg%3E", style: { width: '100%', height: 100, objectFit: 'cover', borderRadius: 6 } }), _jsx("div", __assign({ className: "label" }, { children: "\u0411\u044B\u043B\u043E" }))] })), _jsxs("div", __assign({ className: "photoBlock" }, { children: [_jsx(Image, { src: req.photoUrl, alt: "\u041D\u043E\u0432\u043E\u0435", style: { width: '100%', height: 100, objectFit: 'cover', borderRadius: 6 } }), _jsx("div", __assign({ className: "label" }, { children: "\u041D\u043E\u0432\u043E\u0435" }))] }))] })), _jsx("p", __assign({ style: { fontWeight: 600, margin: '4px 0' } }, { children: profileName || '—' })), _jsx("p", __assign({ style: { fontSize: 12, color: '#666' } }, { children: ((_h = req.user) === null || _h === void 0 ? void 0 : _h.phoneNumber) || ((_j = req.user) === null || _j === void 0 ? void 0 : _j.login) || "user #".concat(req.userId) })), (snap === null || snap === void 0 ? void 0 : snap.gender) && (_jsxs("p", __assign({ style: { fontSize: 12, color: '#666' } }, { children: ["\u041F\u043E\u043B: ", snap.gender] }))), ((_k = snap === null || snap === void 0 ? void 0 : snap.interests) === null || _k === void 0 ? void 0 : _k.length) ? (_jsxs("p", __assign({ style: { fontSize: 11, color: '#888' } }, { children: ["\u0418\u043D\u0442\u0435\u0440\u0435\u0441\u044B: ", snap.interests.slice(0, 5).join(', '), snap.interests.length > 5 ? '…' : ''] }))) : null, _jsx("p", __assign({ style: { fontSize: 11, color: '#aaa' } }, { children: new Date(req.createdAt).toLocaleString('ru-RU') })), _jsx(Tag, __assign({ icon: req.status === 'approved' ? (_jsx(CheckCircleOutlined, {})) : req.status === 'rejected' ? (_jsx(CloseCircleOutlined, {})) : (_jsx(ClockCircleOutlined, {})), color: req.status === 'approved'
                                            ? 'success'
                                            : req.status === 'rejected'
                                                ? 'error'
                                                : 'processing' }, { children: statusLabels[req.status] })), req.rejectionReason && (_jsx("p", __assign({ style: { fontSize: 11, color: '#cf1322', marginTop: 4 } }, { children: req.rejectionReason }))), req.status === 'pending' && (_jsxs("div", __assign({ style: { display: 'flex', gap: 8, marginTop: 8 } }, { children: [_jsx(Button, __assign({ type: "primary", size: "small", block: true, disabled: !actionsEnabled, onClick: function () { return handleApprove(req.id); } }, { children: "\u041E\u0434\u043E\u0431\u0440\u0438\u0442\u044C" })), _jsx(Button, __assign({ danger: true, size: "small", block: true, disabled: !actionsEnabled, onClick: function () { return openReject(req.id); } }, { children: "\u041E\u0442\u043A\u043B\u043E\u043D\u0438\u0442\u044C" }))] }))), _jsx(Button, __assign({ type: "link", size: "small", danger: true, disabled: !actionsEnabled, onClick: function () { return handleDelete(req.id); }, style: { padding: 0, marginTop: 4 } }, { children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C" }))] }), req.id));
                        }) })), !requests.length && (_jsx("p", __assign({ style: { marginTop: 24, color: '#888' } }, { children: "\u0417\u0430\u044F\u0432\u043E\u043A \u043F\u043E\u043A\u0430 \u043D\u0435\u0442" })))] })), _jsxs(Modal, __assign({ title: "\u041E\u0442\u043A\u043B\u043E\u043D\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443", open: rejectModal.open, onCancel: function () { return setRejectModal({ id: 0, open: false }); }, onOk: handleRejectSubmit, okText: "\u041E\u0442\u043A\u043B\u043E\u043D\u0438\u0442\u044C", okButtonProps: { danger: true }, cancelText: "\u041E\u0442\u043C\u0435\u043D\u0430" }, { children: [_jsx("p", __assign({ style: { marginBottom: 8 } }, { children: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 (\u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E, \u0431\u0443\u0434\u0435\u0442 \u0432 push \u0438 \u0432 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438):" })), _jsx(Input.TextArea, { rows: 3, value: rejectReason, onChange: function (e) { return setRejectReason(e.target.value); }, maxLength: 500, placeholder: "\u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440: \u0444\u043E\u0442\u043E \u043D\u0435 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u0435\u0442 \u043F\u0440\u0430\u0432\u0438\u043B\u0430\u043C" })] }))] })));
};
export default ProfileModerationPage;
